import drag from "$root/assets/images/drag.svg";
import { DraggableList, type DraggableListProps } from "@mdotm/shadcn/legacy/components";
import {
	type NodeOrFn,
	overrideClassName,
	renderNodeOrFn,
	toClassListRecord,
	toClassName,
} from "@mdotm/shadcn/legacy/react-extensions";
import type { ReactNode } from "react";

function Draggable<T>(
	props: Omit<DraggableListProps<T>, "children"> & {
		children: NodeOrFn<{ data: T; dragIcon: ReactNode; isDragging: boolean, index: number }>;
	},
) {
	return (
		<DraggableList disabled={props.disabled} items={props.items} onReorder={props.onReorder} itemKey={props.itemKey}>
			{({ draggableProps, dragHandleProps, isDragging, item, innerRef, index }) => (
				<div
					{...draggableProps}
					className={overrideClassName("flex bg-white items-center", {
						"shadow-2xl": isDragging,
						...toClassListRecord(props.className),
					})}
					ref={innerRef}
				>
					{renderNodeOrFn(props.children, {
						data: item,
						dragIcon: (
							<div
								{...dragHandleProps}
								className={toClassName({
									"shrink-0": true,
									"hidden cursor-none": props.disabled,
								})}
							>
								<img src={drag} alt="drag" />
							</div>
						),
						isDragging,
						index,
					})}
				</div>
			)}
		</DraggableList>
	);
}

export default Draggable;
